import createAxios from './api'

const PATH = 'businessAccounts'

export default {

  /**
   * POST /businessAccounts
   * @param {Object} req { name, members: [{userId,isAdmin?}], providers: [{name,monthlyLimit,yearlyLimit}] }
   */
  async createBusinessAccount(req) {
    const axios = await createAxios()
    const resp = await axios.post(`${PATH}`, req)
    return resp.data
  },

  /**
   * PUT /businessAccounts/{id}
   * @param {number|string} id
   * @param {Object} req
   */
  async updateBusinessAccount(id, req) {
    const axios = await createAxios()
    const resp = await axios.put(`${PATH}/${id}`, req)
    return resp.data
  },

  /**
   * GET /businessAccounts?page-size=...&page-num=...&sort-field=...&sort-order=...
   * @param {Object} pageRequest e.g. { 'page-size': 10, 'page-num': 1, 'sort-field': 'name', 'sort-order': 'ASC' }
   */
  async listBusinessAccounts(pageRequest = {}) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}`, {
      params: {
        ...pageRequest
      }
    })
    return resp.data
  },

  /**
   * GET /businessAccounts/{baId}/{providerId}/usages?page-size=...&page-num=...&sort-field=...&sort-order=...
   * @param {string} baId  business account id
   * @param {string} providerId  provider id
   * @param {string} q  searchfield
   * @param {Object} pageRequest e.g. { 'page-size': 10, 'page-num': 1, 'sort-field': 'name', 'sort-order': 'ASC' }
   */
  async listBusinessAccountProviderUsages(baId, providerId, q, pageRequest = {}) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/${baId}/${providerId}/usages`, {
      params: {
        q,
        ...pageRequest
      }
    })
    return resp.data
  },

  /**
   * GET /businessAccounts/{id}
   * @param {string} id
   */
  async getBusinessAccount(id) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/${id}`)
    return resp.data
  },

  /**
   * DELETE /businessAccounts/{id}
   * @param {string} id
   */
  async deleteBusinessAccount(id) {
    const axios = await createAxios()
    await axios.delete(`${PATH}/${id}`)
  },

  /**
   * PUT /businessAccounts/defaultBusinessAccountManagerEmail
   * @param {Object} req { email }
   */
  async updateDefaultBusinessAccountManagerEmail(req) {
    const axios = await createAxios()
    await axios.put(`${PATH}/defaultBusinessAccountManagerEmail`, req)
  },

  /**
   * GET /businessAccounts/defaultBusinessAccountManagerEmail
   */
  async getDefaultBusinessAccountManagerEmail() {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/defaultBusinessAccountManagerEmail`)
    return resp.data
  },

  /**
   * GET /businessAccounts/self?page-size=...&page-num=...&sort-field=...&sort-order=...
   * @param {Object} pageRequest
   */
  async listMyBusinessAccounts(pageRequest = {}) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/self`, {
      params: {
        ...pageRequest
      }
    })
    return resp.data
  },

  /**
   * GET /businessAccounts/self/{id}
   * @param {string} id
   */
  async getMyBusinessAccountAdv(id) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/self/${id}`)
    return resp.data
  },

  async getMyBusinessAccount() {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/self`)
    return resp.data
  },

  /**
   * POST /businessAccounts/sendCreationRequest
   * @param {Object} req { name, email, phoneNumber? }
   */
  async sendBusinessAccountCreationRequest(req) {
    const axios = await createAxios()
    const resp = await axios.post(`${PATH}/sendCreationRequest`, req)
    return resp.data
  },

  async inviteMember(baId, req) {
    const axios = await createAxios()
    const resp = await axios.post(`${PATH}/${baId}/members`, req)
    return resp.data
  },

  async removeMember(baId, userId) {
    const axios = await createAxios()
    const resp = await axios.delete(`${PATH}/${baId}/members/${userId}`)
    return resp.data
  },

  async updateMember(baId, userId, req) {
    const axios = await createAxios()
    await axios.put(`${PATH}/${baId}/members/${userId}`, req)
  },

  async acceptInvitation(baId) {
    const axios = await createAxios()
    const resp = await axios.post(`${PATH}/${baId}/members/accept`)
    return resp.data
  },

  async declineInvitation(baId) {
    const axios = await createAxios()
    const resp = await axios.post(`${PATH}/${baId}/members/decline`)
    return resp.data
  },

  async listMembers(baId, q, pageRequest) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/${baId}/members`, {
      params: {
        q,
        ...pageRequest
      }
    })

    return resp.data
  },

  async updateDefaultProviderLimits(req) {
    const axios = await createAxios()
    await axios.put('users/defaultProviderLimits', req)
  },

  async getDefaultProviderLimits() {
    const axios = await createAxios()
    const resp = await axios.get('users/defaultProviderLimits')
    return resp.data
  }

}
